module.exports = "/images/visa.svg?03a954704e16617d335ba9c37663c3e2";